var scope_0 = require('/workspaces/debt-collection-lab/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/16683ebf113504a9d8cf683b8610b3d2.js').default;
var scope_1 = require('/workspaces/debt-collection-lab/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/377b57a780232378d75289258389813b.js').default;
var scope_2 = require('/workspaces/debt-collection-lab/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3a88c98fcb43e51da1ac23128b397181.js').default;
var scope_3 = require('/workspaces/debt-collection-lab/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/698e7a3e503f0627532b181b0b5e941e.js').default;
var scope_4 = require('/workspaces/debt-collection-lab/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6bd8266ac5cf9955a5792317e27c9ae7.js').default;
var scope_5 = require('/workspaces/debt-collection-lab/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/865da7ac7b5e04f670726b341051ee10.js').default;
var scope_6 = require('/workspaces/debt-collection-lab/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9de665561ba265bf4e72699d03d30b03.js').default;
var scope_7 = require('/workspaces/debt-collection-lab/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/aa340aa9c1428667245b88c32ba877ef.js').default;
var scope_8 = require('/workspaces/debt-collection-lab/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/caff282c98a9ac1ed7d60c4bd5d57654.js').default;
var scope_9 = require('/workspaces/debt-collection-lab/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9 )
    